import { render, staticRenderFns } from "./BListCard.vue?vue&type=template&id=f86f5eba&scoped=true"
import script from "./BListCard.vue?vue&type=script&lang=js"
export * from "./BListCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f86f5eba",
  null
  
)

export default component.exports